import { createAction } from 'redux-actions';

import fetch from 'features/common/fetch';
import user from 'features/views/user';

import * as types from './actionTypes';

export const setBruttoProductionList = createAction(types.SET_BRUTTO_PRODUCTION_LIST, (bruttoProductionList) => ({
	bruttoProductionList,
}));

export const loadBruttoProduction = (contact) => (dispatch, getState) => {
	const { solver, id } = contact;
	const { manager, seller } = solver;

	const orgStruct = {
		channelId: seller.channelId,
		regionId: solver.regionId,
		agencyIds: [solver.agencyId],
		manager: manager.login,
		seller: seller.login,
	};

	dispatch(
		fetch.actions.post(fetch.constants.urls.productionBruttoList, {
			queryParams: { size: 100 },
			body: {
				contactId: id,
				orgStruct,
				userRole: user.selectors.getCurrentRole(getState()),
			},
			onSuccess: [
				(response) => () => {
					const data = response.body.data;
					if (!data || !Array.isArray(data)) return;
					dispatch(setBruttoProductionList(data));
				},
			],
		}),
	);
};

export const reloadBrutto = () => (dispatch, getState) => {
	const { body } = fetch.selectors.getLastRequest(fetch.constants.urls.productionBruttoList)(getState());
	dispatch(
		fetch.actions.post(fetch.constants.urls.productionBruttoList, {
			queryParams: { size: 100 },
			body,
			onSuccess: [
				(response) => () => {
					const data = response.body.data;
					if (!data || !Array.isArray(data)) return;
					dispatch(setBruttoProductionList(data));
				},
			],
		}),
	);
};
